import React from 'react'
import 'antd/dist/antd.css';
import { Steps } from 'antd';

const { Step } = Steps;

const steps = [
  {
    title: 'Product Name',
    content: 'First-content',
  },
    {
      title: 'Pricing Modules',
      content: 'Second-content',
    },
    {
      title: 'Pricing Units',
      content: 'Third-content',
    },
  ];

function Stepper({currentStep}) {

    // const [current, setCurrent] = useState(0)
    return (
        
              <Steps current={Number(currentStep) - 1 } 
              style={{width: '100%'}}> 
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        
        
    )
}

Stepper.propTypes = {

}

export default Stepper

